function plugin(Vue) {
    if (plugin.installed) {
        return;
    }

    !Vue.prototype.$auth &&
        Object.defineProperties(Vue.prototype, {
            $auth: {
                get() {
                    const _this = this;
                    return (requiredPermissions) => {
                        const [requiredPermission, requiredAction] = requiredPermissions.split('.');
                        const permissions = _this.$store.getters.permissions;
                        return (
                            permissions[requiredPermission] &&
                            permissions[requiredPermission].includes(requiredAction)
                        );
                    };
                }
            }
        });
}

export default plugin;
